"use client";
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Carousel } from "react-responsive-carousel";
import { Segmant } from "../../../components";
import Slider from "react-slick";
import { NewItemData } from "../../../components";
import Moment from "react-moment";
import { Grid, Divider, Icon, Dropdown, Loader } from "semantic-ui-react";

const rateoptions = [
  {
    key: "1",
    text: "1",
    value: "1",
  },
  {
    key: "2",
    text: "2",
    value: "2",
  },
  {
    key: "3",
    text: "3",
    value: "3",
  },
  {
    key: "4",
    text: "4",
    value: "4",
  },
  {
    key: "5",
    text: "5",
    value: "5",
  },
];

const Gallery = ({
  imageData,
  selectedItem,
  user_id,
  is_editor,
  removephoto,
  editphotocaption,
  onRatemodal,
  is_static,
  modalhelpful,
  isloaderactive,
  ismodalopen,
  nhid,
  street,
  islistingmodalopen,
}) => {
  let icons = process.env.NEXT_PUBLIC_CDN_ID + "static/images/icon.jpg";
  street ? imageData.push(icons) : null;

  const checkdimension = (imgheight) => {
    let modalbox = document.querySelector(".ReactModal__Content");
    if (modalbox !== undefined && modalbox !== null) {
      return modalbox.offsetHeight - 125 + "px";
      // if (imgheight < modalbox.offsetHeight) {
      //   return modalbox.offsetHeight - 125 + "px";
      // } else {
      //   return "auto";
      // }
    }
  };
  return (
    <div>
      <Segmant className="pr-0 popup_slider">
        {islistingmodalopen ? (
          <Carousel
            showIndicators={false}
            infiniteloop={true}
            autoPlay={false}
            interval={2000}
            // onClickItem={(e) => openpopup(e, length)}
            selectedItem={selectedItem}
          >
            {imageData &&
              ismodalopen === true &&
              imageData.map((image, index) => {
                let img = new Image();
                img.src = image.imageurl;
                let imgheight = checkdimension(img.height);
                // }
                return (
                  <div
                    key={index}
                    id={`imgdata${index}`}
                    style={{
                      height: imgheight && imgheight,
                      width: image.username && "80%",
                    }}
                  >
                    <img
                      src={image.imageurl + "?cacheblock=true"}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src =
                          process.env.NEXT_PUBLIC_CDN_ID +
                          "static/images/defaultadd.jpg";
                      }}
                      crossOrigin="anonymous"
                      style={{ height: imgheight && imgheight }}
                      title="City Picture"
                      alt="City Photo"
                    />

                    <div className="model_slider_desc">
                      {image.username && (
                        <NewItemData
                          size="tiny"
                          source={
                            image.userimage &&
                            image.userimage !== "$context.arguments.userimage"
                              ? image.userimage
                              : process.env.NEXT_PUBLIC_CDN_ID +
                                "static/images/Milad.png"
                          }
                          head={image.username}
                          subhead={image.userrole}
                          // desc={grid.desc}
                          href="/ProfileRealtor"
                          className="user_data_modal"
                          userid={image.user_id}
                        />
                      )}
                      {is_static === false && (
                        <>
                          {image.caption && (
                            <p className="slider_cap">{image.caption}</p>
                          )}
                          {/* {image.date && (
                            <p className="slider_date">
                              <Moment format="DD MMMM, YYYY">
                                {image.date}
                              </Moment>
                            </p>
                          )} */}
                          {image.user_id === user_id ? (
                            <>
                              {/* <p>Was this photo...?</p> */}
                              <span className="helpful_slider" disabled={true}>
                                <i
                                  aria-hidden="true"
                                  className="thumbs up outline icon"
                                ></i>{" "}
                                Helpful {image.imagehelpfulcount}
                              </span>
                            </>
                          ) : (
                            user_id != "" && (
                              <>
                                {/* <p>Was this photo...?</p> */}
                                <span
                                  className="helpful_slider"
                                  onClick={(e) =>
                                    modalhelpful(e, image.id, image)
                                  }
                                  style={{ cursor: "pointer" }}
                                >
                                  <i
                                    aria-hidden="true"
                                    className="thumbs up outline icon"
                                  ></i>{" "}
                                  Helpful {image.imagehelpfulcount}{" "}
                                  {isloaderactive && (
                                    <Loader size="mini" inline active />
                                  )}
                                </span>
                              </>
                            )
                          )}

                          {image.user_id === user_id && (
                            <div className="photo_owners">
                              <p>Photo Owner's View</p>
                              <span
                                style={{ color: "#4183c4", cursor: "pointer" }}
                                onClick={(e) =>
                                  editphotocaption(e, image.id, image.caption)
                                }
                              >
                                <i
                                  aria-hidden="true"
                                  className="pencil alternate icon"
                                ></i>{" "}
                                Edit photo caption
                              </span>
                              <br />
                              <span
                                style={{ color: "#4183c4", cursor: "pointer" }}
                                onClick={(e) => removephoto(e, image.id)}
                              >
                                <i
                                  aria-hidden="true"
                                  className="trash alternate icon"
                                ></i>{" "}
                                Remove photo
                              </span>
                            </div>
                          )}
                          {is_editor && (
                            <div className="editors_view">
                              <p>Editors's View</p>
                              <span
                                style={{ color: "#4183c4", cursor: "pointer" }}
                                onClick={(e) => removephoto(e, image.id)}
                              >
                                <i
                                  aria-hidden="true"
                                  className="trash alternate icon"
                                ></i>{" "}
                                Remove photo
                              </span>
                              <br />
                              <br />
                              <span className="rate_drpdwn rate_drpdwn_modal">
                                <Dropdown
                                  text="Rate"
                                  //icon='add user'
                                  floating
                                  labeled
                                  button
                                  upward
                                >
                                  <Dropdown.Menu>
                                    <Dropdown.Header content="Rate" />
                                    {rateoptions &&
                                      rateoptions.map((option) => (
                                        <Dropdown.Item
                                          key={option.value}
                                          {...option}
                                          onClick={(e) =>
                                            onRatemodal(image.id, e)
                                          }
                                        />
                                      ))}
                                  </Dropdown.Menu>
                                </Dropdown>
                              </span>
                              <span>{image.rate}</span>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                );
              })}
          </Carousel>
        ) : (
          <>
            <Loader active inline="centered" size="massive" />
          </>
        )}
      </Segmant>
    </div>
  );
};

Gallery.propTypes = {
  imageData: PropTypes.array.isRequired,
  button: PropTypes.bool,
};
export default Gallery;
